<template>
  <span
    :class="[
      'map-button',
      type,
      {
        actived
      }
    ]"
    @click="click"
  >
    <span v-if="title" class="title">{{ title }}</span>
    <i class="map-button-icon" v-if="type === 'icon'" :title="title">
      <img v-if="icon" :src="icon" />
      <slot v-if="!icon" name="icon"></slot>
    </i>
  </span>
</template>

<script>
// 地图上工具按钮
export default {
  props: {
    icon: String,
    actived: Boolean,
    title: String,
    type: {
      type: String,
      default: 'icon'
    }
  },
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="less" scoped>
.map-button {
  display: flex;
  padding: 0 10px;
  cursor: pointer;

  .title {
    font-size: 14px;
    line-height: 32px;
  }

  &.text {
    &.actived {
      background-color: #056c85;
    }
  }

  &.icon {
    &.actived {
      .map-button-icon {
        background-color: #056c85;
      }
    }
  }

  .map-button-icon {
    display: block;
    height: 33px;
    width: 33px;
    line-height: 33px;
    margin-left: 10px;

    img {
      height: 20px;
      width: 20px;
      display: block;
      margin: 6px;
    }

    i {
      font-size: 16px;
      margin: 8px;
    }
  }
}
</style>
